import { DateTime } from 'luxon';
const DEFAULT_FORMATS = ['yy-M-d', 'yy/M/d', 'M/d/yy', 'MMM d, yy', 'MMMM d, yy'];
export const parseDate = function (value) {
  let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FORMATS;
  if (!value) {
    return DateTime.invalid('No value provided');
  }
  if (!formats || formats.length === 0) {
    return DateTime.fromISO(value);
  }
  let parsed = DateTime.invalid('No format provided');
  formats.some(format => {
    parsed = DateTime.fromFormat(value, format);
    return parsed.isValid;
  });
  return parsed;
};
export const isValidDate = function (value) {
  let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FORMATS;
  if (!value) {
    return false;
  }
  return parseDate(value, formats).isValid;
};
export function parseDateToNumberStrings(value) {
  let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FORMATS;
  const parsed = parseDate(value, formats);
  return {
    month: parsed.isValid ? parsed.month.toString() : '',
    day: parsed.isValid ? parsed.day.toString() : '',
    year: parsed.isValid ? parsed.year.toString() : ''
  };
}